import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Accommodations Queue|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamAccommodations,
	portal: 'SP',
};

type LocNameStart = 'SPToolsAccommsQueue';
export type SPToolsAccommsQueueLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelAccommodation`
	| `${LocNameStart}LabelRequestDate`
	| `${LocNameStart}LabelDaysInQueue`
	| `${LocNameStart}LabelCandidateName`;

export const spToolsAccommsQueueLocs: LocDefs<SPToolsAccommsQueueLocNames> = {
	SPToolsAccommsQueueTitleTab: {
		defaultValue: 'Accommodations Queue',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam.Accommodations/Tools.AccommodationQueue.Title.Tab',
		...sharedProperties,
	},
	SPToolsAccommsQueueLabelAccommodation: {
		defaultValue: 'Accommodation',
		description: 'Column heading for: Accommodation.',
		displayPath: `${pathStart}Accommodation`,
		displayType: 'Label',
		legacyName: 'Exam.Accommodations/Tools.AccommodationQueue.ColumnHeading.Accommodation',
		...sharedProperties,
	},
	SPToolsAccommsQueueLabelRequestDate: {
		defaultValue: 'Request Date',
		description: 'Column heading for: Request Date.',
		displayPath: `${pathStart}Request Date`,
		displayType: 'Label',
		legacyName: 'Exam.Accommodations/Tools.AccommodationQueue.ColumnHeading.RequestDate',
		...sharedProperties,
	},
	SPToolsAccommsQueueLabelDaysInQueue: {
		defaultValue: 'Days In Queue',
		description: 'Column heading for: Days In Queue.',
		displayPath: `${pathStart}Days In Queue`,
		displayType: 'Label',
		legacyName: 'Exam.Accommodations/Tools.AccommodationQueue.ColumnHeading.DaysInQueue',
		...sharedProperties,
	},
	SPToolsAccommsQueueLabelCandidateName: {
		defaultValue: 'Candidate Name',
		description: 'Column heading for: Candidate Name.',
		displayPath: `${pathStart}Candidate Name`,
		displayType: 'Label',
		legacyName: 'Exam.Accommodations/Tools.AccommodationQueue.ColumnHeading.Candidate',
		...sharedProperties,
	},
};

export type SPToolsAccommsQueueLocType = LocMap<SPToolsAccommsQueueLocNames>;
